import {Reorder} from 'framer-motion';
import {DataStatus} from 'platform/components';

import {isEmpty} from 'ramda';

import {noop} from 'shared/web';

import {useDocumentSelection} from '../../contexts/DocumentSelectionProvider';
import {DocumentItemWithIsSelected} from '../../types/DocumentItemWithIsSelected';
import {DocumentItem} from './DocumentItem';

export function DocumentSelectionList() {
  const {documents, selectDocument, deselectDocument} = useDocumentSelection();

  const handleOnClick = (document: DocumentItemWithIsSelected) => {
    const selectAction = document.isSelected ? deselectDocument : selectDocument;
    selectAction(document.fileId);
  };

  return (
    <Reorder.Group
      axis="y"
      values={documents}
      onReorder={noop}
      as="div"
      layoutScroll
      style={{overflowY: 'scroll', height: '100%'}}
    >
      <DataStatus isEmpty={isEmpty(documents)} minHeight="100%">
        {documents.map((document) => (
          <DocumentItem document={document} key={document.fileId} onClick={handleOnClick} />
        ))}
      </DataStatus>
    </Reorder.Group>
  );
}
